
import smoothscroll from 'smoothscroll-polyfill'

export default {
  name: 'LocalNav',

  props: {
    list: {
      type: Array,
      defaults: []
    },
    offset: {
      type: Number,
      default: 110
    },
    showPc: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any) {
    smoothscroll.polyfill()

    const scrollContents = (anchor: string) => {
      const el = document.getElementById(anchor)
      if (!el) return
      window.scrollTo({
        top: el.offsetTop - props.offset,
        behavior: 'smooth'
      })
    }

    return {
      scrollContents
    }
  }
}
